/**
 * Collects field-audit entries and write destinations for one aggregate save
 * ({@link OrgScopedCrudService.withAggregateVersion}).
 *
 * Destination keys are noted as children (and the parent) enqueue writes so the
 * owner of the commit can decide atomic vs split (request 0250 / spec 0046 §10).
 */
export class AggregateAuditScope {
    constructor(recorder, 
    /** Parent aggregate identity + record (for `aggregateLabel` on every child op). */
    aggregate) {
        this.recorder = recorder;
        this.aggregate = aggregate;
        this.keys = [];
    }
    /** Called by whoever enqueues a business write on the aggregate batch. */
    noteDestination(repository) {
        this.keys.push(repository.getWriteBatchSupport?.()?.destinationKey ?? null);
    }
    get destinationKeys() {
        return this.keys;
    }
}
//# sourceMappingURL=AggregateAuditScope.js.map